import React, { useState, useEffect } from 'react';
import { attributionAPI } from '../../../services/api';

const formatPct = (v) => {
  if (v === null || v === undefined) return '—';
  if (typeof v !== 'number' || !isFinite(v)) return '—';
  return `${v.toFixed(2)}%`;
};

// Weights are stored as decimals (0.09 = 9%) — multiply by 100 to display
const formatWeight = (v) => {
  if (v === null || v === undefined) return '—';
  if (typeof v !== 'number' || !isFinite(v)) return '—';
  return `${(v * 100).toFixed(2)}%`;
};

const TopBottomContributors = ({ portfolioCode, reportType, periodEnd, rangeStart, rangeEnd }) => {
  const [contributions, setContributions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!portfolioCode) return;

    if (reportType === 'RANGE') {
      if (!rangeStart || !rangeEnd) return;
      setLoading(true);
      attributionAPI.getRangeContributions(portfolioCode, { start_date: rangeStart, end_date: rangeEnd })
        .then((data) => { setContributions(data); setLoading(false); })
        .catch((err) => { console.error('Failed to load range contributions', err); setLoading(false); });
      return;
    }

    setLoading(true);
    const params = { report_type: reportType };
    if (reportType !== 'SI' && periodEnd) params.period_end = periodEnd;
    attributionAPI.getContributions(portfolioCode, params)
      .then((data) => { setContributions(data); setLoading(false); })
      .catch((err) => { console.error('Failed to load contributions', err); setLoading(false); });
  }, [portfolioCode, reportType, periodEnd, rangeStart, rangeEnd]);

  if (loading) return <div className="stats-loading">Loading…</div>;
  if (!contributions.length) return <div className="stats-empty">No contributions data available.</div>;

  const top = contributions.filter(c => c.scope === 'top' && (c.contribution_to_portfolio_return ?? 0) > 0);
  const bottom = contributions.filter(c => c.scope === 'bottom' && (c.contribution_to_portfolio_return ?? 0) < 0);

  return (
    <div className="contributors-wrapper">
      <ContributorsSection title="Top Contributors" rows={top} />
      <ContributorsSection title="Bottom Contributors" rows={bottom} />
    </div>
  );
};

const ContributorsSection = ({ title, rows }) => (
  <div className="contributors-section">
    <h3 className="contributors-section-title">{title}</h3>
    {rows.length === 0 ? (
      <p className="contributors-empty">No data.</p>
    ) : (
      <table className="contributors-table">
        <thead>
          <tr>
            <th>Holding</th>
            <th className="num">Active Wt</th>
            <th className="num">Contribution</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i}>
              <td>{r.issue_name}</td>
              <td className="num">{formatWeight(r.weight_difference)}</td>
              <td className={`num ${(r.contribution_to_portfolio_return ?? 0) >= 0 ? 'pos' : 'neg'}`}>
                {formatPct(r.contribution_to_portfolio_return)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
);

export default TopBottomContributors;
